<template>
  <div :class="widthValid == true ? 'dados mt-2' : 'dados mt-5'">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 mt-3">
        <h1 class="font-weight-bold text-uppercase tamanhoFonte">Seus pedidos de cadastrado</h1>
      </div>

      <div :class="widthValid == true ? 'col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4' : 'col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-4'">
        <button class="btn btn-success btn-block" @click="newLojista()">
          <i class="fas fa-plus mr-2"></i>Nova recomendação
        </button>
      </div>
    </div>

    <hr class="linha-amarela ml-2" />

    <div class="row mt-4">
      <div class="col-12">
        <i class="fas fa-users fa-2x c-orange mr-2"></i>
        <h4 class="text-uppercase c-orange font-weight-bold d-inline">
          Recomendações
        </h4>
      </div>
      
      <div class="col-12 mt-2" style="overflow-x: auto;">
        <table class="table">
          <thead class="letter-orange">
            <tr>
              <th>Nome responsável</th>
              <th>Nome fantasia</th>
              <th>CNPJ</th>
              <th>WhatsApp</th>
              <th>Cidade - UF</th>
              <th>Status</th>
              <th>Obs.</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in data" :key="i">
              <td>{{ item.nome_responsavel }}</td>
              <td>{{ item.nome_fantasia }}</td>
              <td>{{ formatDoc('cnpj', item.cnpj) }}</td>
              <td>{{ formatDoc('cell', item.whatsapp) }}</td>
              <td>{{ item.cidade_uf }}</td>
              <td>{{item.status}}</td>
              <td>
                <span class="btn btn-primary" @click="verObs(item.observacao)">
                  <i class="fas fa-eye"></i>
                </span>
              </td>              
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal
      title="Nova recomendação"
      size="xl"
      id="addLojista"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
        <div class="row">
          <div class="col-6">
            <label>Nome responsável</label>
            <input type="text" class="form-control" v-model="fields.nome_responsavel" placeholder="Nome do responsável">
          </div>

          <div class="col-6">
            <label>Nome fantasia</label>
            <input type="text" class="form-control" v-model="fields.nome_fantasia" placeholder="Nome do fantasia">
          </div>

          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
            <label>CNPJ</label>
            <input type="text" class="form-control" v-model="fields.cnpj" @blur="buscarCnpj()" placeholder="##.###.###/####-##" v-mask="'##.###.###/####-##'">
          </div>

          <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 mt-2">
            <label>WhatsApp</label>
            <input type="text" class="form-control" v-model="fields.whatsapp" placeholder="(##) # ####-####" v-mask="['(##) ####-####', '(##) # ####-####']">
          </div>

          <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 mt-2">
            <label>Cidade - UF</label>
            <input type="text" class="form-control" v-model="fields.cidade_uf" placeholder="Cidade - UF">
          </div>

          <div class="col-12 mt-2">
            <label>Observação</label>
            <textarea type="text" class="form-control" v-model="fields.observacao" placeholder="Digite aqui..."></textarea>
          </div>

          <div class="col-12 mt-4 text-center">
            <button class="btn btn-success" @click="salvarDados()">
              <i class="fas fa-save mr-2"></i>
              Salvar
            </button>
          </div>
        </div>
    </b-modal>

    <b-modal
      title="Ver Observação"
      id="verObs"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
        <div class="row">
          <div class="col-12">
            <span>
              {{observacao ? observacao : 'Sem Observação'}}
            </span>
          </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import makeToast from "../../mixins/makeToast";

export default {
  name: "NovoLojista",
  mixins: [makeToast],

  data: () => ({
    widthValid: false,
    fields: {
      nome_responsavel: '',
      nome_fantasia: '',
      cnpj: '',
      whatsapp: '',
      cidade_uf: '',
      observacao: '',
      gerente_id: null
    },
    observacao: '',
    value: '',
    codGerente: null,
    data: []
  }),

  computed: {
    ...mapState(['dadosUsuario'])
  },

  created() {
    var larguraTela = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    
    if(larguraTela < 500) {
      this.widthValid = true;
    }

    this.buscarRecomendacoes();
  },

  methods: {
    buscarCnpj() {
      const cnpj = this.fields.cnpj.replace(/[^0-9]/g, '');

      this.$store.dispatch('startLoader');
      this.$store.dispatch('user/validarCnpj', cnpj)
        .then(async (response) => {
          if(response.data.valid == true) {
            this.fields.cnpj = '';
            this.makeToast('Oopss!', 'Esse CNPJ já está sendo utilizado, informe outro!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    verObs(text) {
      this.observacao = text;
      this.$bvModal.show('verObs');
    },
    newLojista() {
      this.limparDados();
      this.$bvModal.show('addLojista');
    },
    salvarDados() {
      const valid = this.validarDados();
      if(valid == true) {

        this.fields.gerente_id = this.dadosUsuario.informacoes.id;

        this.$store.dispatch('startLoader');
        this.$store.dispatch('gerente/salvarRecomendacao', this.fields)
          .then((response) => {
            if(response.data.error == false) {
              this.makeToast('sucesso', response.data.message, 'success');
              this.$bvModal.hide('addLojista');

              this.buscarRecomendacoes();
            } else {
              this.makeToast('Oopss', response.data.message, 'danger')
            }            
          })
          .catch(() => {
            this.makeToast('Oopss', 'Erro ao atualizar!', 'danger')
          })
          .finally(() => {
            this.$store.dispatch('endLoader')
          });
      }
    },
    validarDados() {
      var error = true;
      if(this.fields.nome_responsavel == '') {
        this.makeToast('Oopss', 'Informe o nome do responsável!', 'danger')
        error = false;
      }
      if(this.fields.nome_fantasia == '') {
        this.makeToast('Oopss', 'Informe o nome fantasia!', 'danger')
        error = false;
      }
      if(this.fields.cnpj == '') {
        this.makeToast('Oopss', 'Informe o CNPJ!', 'danger')
        error = false;
      }
      if(this.fields.whatsapp == '') {
        this.makeToast('Oopss', 'Informe o WhatsApp!', 'danger')
        error = false;
      }
      if(this.fields.cidade_uf == '') {
        this.makeToast('Oopss', 'Informe a cidade/uf!', 'danger')
        error = false;
      }

      return error;
    },
    formatDoc(tipo, value) {
      if(tipo == 'cnpj') {
        return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1 $2 $3/$4-$5");
      } else if(tipo == 'cell') {
        if (!value) return ""

        var value = value.replace(/\D/g, "");
        value = value.replace(/^0/, "");

        if (value.length > 10) {
          value = value.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
        } else if (value.length > 5) {
          value = value.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
        } else if (value.length > 2) {
          value = value.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
        } else {
          value = value.replace(/^(\d*)/, "($1");
        }
        return value;
      }
    },
    buscarRecomendacoes() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('gerente/listarRecomendacoes', this.dadosUsuario.informacoes.id)
        .then((response) => {
          if(response.data){
            this.data = response.data;
          }         
        })
        .catch(() => {
          this.makeToast('Oopss', 'Erro ao buscar lojistas!', 'danger')
        })
        .finally(() => {
          this.$store.dispatch('endLoader')
        });
    },
    limparDados() {
      this.fields.nome_fantasia = '';
      this.fields.nome_responsavel = '';
      this.fields.whatsapp = '';
      this.fields.cnpj = '';
      this.fields.cidade_uf = '';
      this.fields.observacao = '';
    }
  },
};
</script>

<style scoped>
@media only screen and (max-width: 500px) {
  .tamanhoFonte{
    font-size: 20px;
  }
}
</style>